/**
 * Locale Utils
 *
 * @since 2018-04-11
 * @author kdydesign.kim
 */

/**
 * get locales file
 * @param locales
 */

// 미번역된 다국어 검증
// {'심볼: 파일 심볼', '파일명:', '키값:번역되지 않은 한글'}
// 베트남어 추가 예정
const regCheck = (value) => {
  // 한글 포함, 특수문자 | 제외
  return value.match(/[ㄱ-ㅎㅏ-ㅣ가-힣]/)
}
// 테스트 중
// const keyCheck = (data, _localesMsgFileNameEn, _localesMsgFileNameKo) => {
//   const msgSet = data
//   const localesMsgFileNameEn = _localesMsgFileNameEn
//   const localesMsgFileNameKo = _localesMsgFileNameKo
//   let unObjectKeyKo = []
//   let unObjectKeyEn = []
//
//   Object.keys(msgSet['ko']).forEach(key => {
//     const objectKey = Object.keys(msgSet['ko'][key])
//     const objectKey2 = Object.keys(msgSet['en'][key])
//     const objectKeyCode = msgSet['en']['code']
//     console.log(objectKeyCode)
//     // ko 파일에만 있는 키
//     const uniqueKeysKo = objectKey.filter(key => !objectKey2.includes(key))
//     // en 파일에만 있는키
//     const uniqueKeysEn = objectKey2.filter(key => !objectKey.includes(key))
//
//     if (uniqueKeysKo.length > 0) {
//       uniqueKeysKo.forEach(item => {
//         unObjectKeyKo.push({
//           'symbol': key,
//           'fileName': localesMsgFileNameKo[key],
//           'key': item,
//           'value': msgSet['ko'][key][item]
//         })
//       })
//     }
//     if (uniqueKeysEn.length > 0) {
//       uniqueKeysEn.forEach(item => {
//         unObjectKeyEn.push({
//           'symbol': key,
//           'fileName': localesMsgFileNameEn[key],
//           'key': item,
//           'value': msgSet['en'][key][item]
//         })
//       })
//     }
//   })
//   console.warn('영문 키값이 없는 데이터')
//   console.table(unObjectKeyKo)
//   console.warn('한글 키값이 없는 데이터')
//   console.table(unObjectKeyEn)
// }
const translationCheck = (data, _localesMsgFileName) => {
  const msgSet = data
  const localesMsgFileName = _localesMsgFileName
  const unTranslated = []

  const loopCheck = (value, symbol, key) => {
    if (regCheck(value)) {
      unTranslated.push({
        'symbol': symbol,
        'fileName': localesMsgFileName[symbol],
        'key': key,
        'value': regCheck(value).input
      })
    }
  }
  for (const key in msgSet) {
    if (key === 'code') { // code.json은 포맷이 다름
      msgSet[key].code.forEach(arr => {
        if (arr.list) { // 객체의 list 속성이 있을때
          arr.list.forEach(item => {
            loopCheck(item['val'], key, arr.group_key)
          })
        } else {
          Object.keys(arr.filter_type).forEach(type => {
            arr.filter_type[type].list.forEach(item => {
              loopCheck(item['val'], key, arr.group_key)
            })
          })
        }
      })
    } else {
      Object.keys(msgSet[key]).forEach(item => {
        loopCheck(msgSet[key][item], key, item)
      })
    }
  }
  const _newUnTranslated = unTranslated.filter(obj => !(obj['key'] === 'comment' || obj['key'] === '_comment'))
  // 미번역된 데이터가 있는지 확인
  if (_newUnTranslated.length > 0) {
    console.warn('미번역 데이터')
    console.table(_newUnTranslated)
  }
}
export function getLocaleMsg (locales) {
  let msgSet = {}
  let localesMsgFileName = {}
  // let localesMsgFileName2 = {} 테스트

  _.forEach(locales, (locale) => {
    const localesMsg = {}

    try {
      localesMsg[locale] = {
        msg: require(`~/static/locales/${locale}/messages_${locale}.json`),
        cmn: require(`~/static/locales/${locale}/common_${locale}.json`),
        sm: require(`~/static/locales/${locale}/system_${locale}.json`),
        an: require(`~/static/locales/${locale}/analysis_${locale}.json`),
        da: require(`~/static/locales/${locale}/dashboard_${locale}.json`),
        lr: require(`~/static/locales/${locale}/logReport_${locale}.json`),
        op: require(`~/static/locales/${locale}/objectSecProfile_${locale}.json`),
        po: require(`~/static/locales/${locale}/securityPolicy_${locale}.json`),
        vp: require(`~/static/locales/${locale}/vpn_${locale}.json`),
        dash: require(`~/static/locales/${locale}/dashboard_${locale}.json`),
        vl: require(`~/static/locales/${locale}/validate_${locale}.json`),
        pa: require(`~/static/locales/${locale}/pams_${locale}.json`),
        cm: require(`~/static/locales/${locale}/cm_${locale}.json`),
        ec: require(`~/static/locales/${locale}/eventCode_${locale}.json`),
        code: require(`~/static/locales/${locale}/code_${locale}.json`)
      }
      // 개발모드의 로그인 첫 페이지에서 확인 가능한 코드
      // 객체로 파일명 초기화
      if (process.env.NODE_ENV === 'development' && window.location.href.includes('loginDev')) {
        if (locale === 'en') {
          localesMsgFileName = {
            msg: `messages_${locale}.json`,
            cmn: `common_${locale}.json`,
            sm: `system_${locale}.json`,
            an: `analysis_${locale}.json`,
            da: `dashboard_${locale}.json`,
            lr: `logReport_${locale}.json`,
            op: `objectSecProfile_${locale}.json`,
            po: `securityPolicy_${locale}.json`,
            vp: `vpn_${locale}.json`,
            dash: `dashboard_${locale}.json`, // da와 중복 데이터
            vl: `validate_${locale}.json`, // TAMS
            pa: `pams_${locale}.json`,
            cm: `cm_${locale}.json`,
            ec: `eventCode_${locale}.json`,
            code: `code_${locale}.json`
          }
        }
        // 키값을 ko, en 키값을 비교하기 위한 로직을 개발 하는 중
        if (locale === 'ko') {
          // localesMsgFileName2 = {
          //   msg: `messages_${locale}.json`,
          //   cmn: `common_${locale}.json`,
          //   sm: `system_${locale}.json`,
          //   an: `analysis_${locale}.json`,
          //   da: `dashboard_${locale}.json`,
          //   lr: `logReport_${locale}.json`,
          //   op: `objectSecProfile_${locale}.json`,
          //   po: `securityPolicy_${locale}.json`,
          //   vp: `vpn_${locale}.json`,
          //   dash: `dashboard_${locale}.json`, // da와 중복 데이터
          //   vl: `validate_${locale}.json`, // TAMS
          //   // TAMS
          //   pa: `pams_${locale}.json`,
          //   cm: `cm_${locale}.json`,
          //   ec: `eventCode_${locale}.json`,
          //   code: `code_${locale}.json`
          // }
        }
      }
      msgSet = _.assign(msgSet, localesMsg)
    } catch (err) {
      console.warn('locales not found..')
    }
  })

  // 개발모드의 로그인 첫 페이지에서 확인 가능한 코드
  if (Object.keys(localesMsgFileName).length > 0) {
    // keyCheck(msgSet, localesMsgFileName, localesMsgFileName2)
    translationCheck(msgSet['en'], localesMsgFileName)
  }
  return msgSet
}
